import { ReactNode } from "react";
import { usePermissions } from "@/hooks/usePermissions";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface ProtectedActionProps {
  module: string;
  action: string;
  children: ReactNode;
  fallback?: ReactNode;
  showTooltip?: boolean;
  tooltipMessage?: string;
}

export function ProtectedAction({
  module,
  action,
  children,
  fallback = null,
  showTooltip = true,
  tooltipMessage = "Você não tem permissão para esta ação",
}: ProtectedActionProps) {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return <>{fallback}</>;
  }

  const canPerformAction = hasPermission(module, action);

  if (!canPerformAction) {
    if (showTooltip && fallback) {
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="opacity-50 cursor-not-allowed">
                {fallback}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{tooltipMessage}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
